import { IntlShape } from "react-intl";

export const KOULUTUSTYYPPI_MESSAGE_IDS: Record<string, string> = {
  "1": "esiJaPerusopetus.jarjestamislupa",
  "2": "lukiokoulutus.jarjestamislupa",
  "3": "vapaaSivistystyo.jarjestamislupa",
  "4": "taiteenPerusopetus.jarjestamislupa",
  "5": "tuva.jarjestamislupa",
  "": "ammatillinenKoulutus.jarjestamislupa"
};

export const getKoulutustyyppiLabel = (intl: IntlShape, koulutustyyppi?: string): string => {
  const messageId = KOULUTUSTYYPPI_MESSAGE_IDS[koulutustyyppi ?? ""];
  if (!messageId) return intl.formatMessage({ id: "common.unknownJarjestamislupa", defaultMessage: "Tuntematon järjestämislupa" });
  return intl.formatMessage({ id: messageId });
};
